export class PostalCodeService {
  static readonly CANADIAN_POSTAL_CODE_REGEX: RegExp = /(?=^[ABCEGHJKLMNPRSTVXY]\d([ABCEGHJKLMNPRSTVWXYZ]\d){2}$)/i;
  static readonly US_POSTAL_CODE_REGEX: RegExp = /^\d{5}$/;
  static readonly OTHER_POSTAL_CODE_REGEX: RegExp = /[a-z0-9]/i;

  constructor() { }

  static formatCanadianPostalCode(postalCode: string): string {
    return PostalCodeService.CANADIAN_POSTAL_CODE_REGEX.test(postalCode)
      ? postalCode.replace(/(...)/, '$1 ')
      : postalCode;
  }
}
